import { render, staticRenderFns } from "./BrowzwearEndpointManager.vue?vue&type=template&id=58300630&scoped=true&"
import script from "./BrowzwearEndpointManager.vue?vue&type=script&lang=js&"
export * from "./BrowzwearEndpointManager.vue?vue&type=script&lang=js&"
import style0 from "./BrowzwearEndpointManager.vue?vue&type=style&index=0&id=58300630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58300630",
  null
  
)

export default component.exports